import React from 'react';
import { Row, Col, Typography, Divider } from 'antd';
import { PhoneOutlined, MailOutlined, EnvironmentOutlined } from '@ant-design/icons';
import Navbar from '../components/Navbar';
import { useTranslation } from 'react-i18next';  
import '../styles/login.css';

const { Title, Paragraph } = Typography;

const locations = [
    {
      titleKey: 'head_office',
      address: 'Ferhatpaşa Mah. 16 Sok. No: 38 Ataşehir / Istanbul 34888',
      phone: '+90 216 471 14 43',
      fax: '+90 216 471 19 24',
      email: 'info@daiichi.com'
    },
    {
      titleKey: 'customer_services',
      address: 'Ferhatpaşa Mah. 16 Sok. No: 38 Ataşehir İstanbul 34888',
      phones: ['+90 216 661 50 59', '+90 216 471 85 70', '+90 216 471 85 75'],
      email: 'info@daiichi.com'
    },
    {
      titleKey: 'finance_office',
      address: 'IFM Finanskent Mah. Finans Cad. No: 46/3 İç Kapı No: 115 Ümraniye İSTANBUL',
      phone: '+90 216 471 14 43',
      email: 'info@daiichi.com'
    },
    {
      titleKey: 'r_and_d_center_gebze',
      address: 'Bilişim Vadisi, Muallimköy Mah. Deniz Cad. No:143 Gebze, Kocaeli',
      phone: '+90 216 661 50 59',
      email: 'info@daiichi.com'
    },
    {
      titleKey: 'r_and_d_center_bursa',
      address: 'Uludağ Üniversitesi Teknoloji Geliştirme Bölgesi Üniversite-1 Cad. No: 933/141 Görükle / BURSA, 16120',
      phone: '+90 224 442 84 09',
      email: 'info@daiichi.com'
    },
    {
      titleKey: 'r_and_d_center_ankara',
      address: 'Bilkent CyberPark Üniversiteler Mah. 1606 Cad. B 2 Blok No : 4B İç Kapı No : 301 Çankaya, ANKARA',
      phone: '+90 216 471 14 43',
      email: 'info@daiichi.com'
    },
    {
      titleKey: 'italy_office',
      address: 'Strada Torino, 43 10043, Orbassano (TO) ITALY',
      phone: '+39 389 955 5488',
      email: 'info@daiichi.com'
    },
    {
      titleKey: 'india_office',
      address: 'SURVEY NO:230 A/1,229, KONARK EPITOME, 3RD FLOOR, OFFICE NO 305, VIMAN NAGAR PUNE 411014',
      phone: '+91 99213 56431',
      email: 'info@daiichi.com'
    },
    {
      titleKey: 'china_office',
      address: 'Room 18G, 18th Floor Seascape Square Taizi Road, Shekou, Nanshan District Shenzhen 518054 China',
      phone: '+86 755 2691 8447',
      email: 'info@daiichi.com'
    },
    {
      titleKey: 'uzbekistan_office',
      address: '2, Karakamishkskaya Street 100190 Tashkent, Uzbekistan',
      phones: ['+99871 150 10 47', '221 47 87'],
      fax: '+99871 150 10 46',
      email: 'info@daiichi.com'
    }
  ];

const Info = () => {
    const { t } = useTranslation();  // Hook
    return (
        <div id='login' style={{ backgroundImage: `url('https://daiichi.com/new_site/wp-content/uploads/2017/11/newsletter.jpg')` }}>
          <Navbar />
          <div 
            className='info-wrapper' 
            style={{ 
              overflowY: 'auto', 
              maxHeight: '80vh', 
              marginTop: '120px', 
              width: '80%', 
              maxWidth: '1000px', 
              padding: '50px 60px', 
              borderRadius: '5px', 
              backdropFilter: 'blur(8px)', 
              backgroundColor: 'rgba(255, 255, 255, 0.1)', 
              border: '2px solid rgba(255, 255, 255, 0.2)', 
              color: '#fff', 
              marginLeft: 'auto', 
              marginRight: 'auto'
            }}
          >
            <div className='contact-content'>
                <Title level={2} style={{ color: '#fff' }}>{t('contact_info_title')}</Title>
                <Paragraph style={{ color: '#fff' }}>
                {t('contact_info_description')}
                </Paragraph>
              <Divider style={{ borderColor: '#fff' }} />
              <Row gutter={[32, 32]}>
                {locations.map((loc, index) => (
                  <Col xs={24} md={12} key={index}>
                    <div className='contact-box' style={{ color: '#fff', marginBottom: '20px', backgroundColor: 'rgba(255, 255, 255, 0.05)', padding: '20px', borderRadius: '5px', backdropFilter: 'blur(4px)' }}>
                    <Title level={4} style={{ color: '#fff' }}>
                    {t(loc.titleKey)}
                    </Title>
                      <Paragraph style={{ color: '#fff' }}><EnvironmentOutlined /> {loc.address}</Paragraph>
                      {loc.phone && <Paragraph style={{ color: '#fff' }}><PhoneOutlined /> {loc.phone}</Paragraph>}
                      {loc.phones && loc.phones.map((p, idx) => (
                        <Paragraph key={idx} style={{ color: '#fff' }}><PhoneOutlined /> {p}</Paragraph>
                      ))}
                      {loc.fax && <Paragraph style={{ color: '#fff' }}><strong>Fax:</strong> {loc.fax}</Paragraph>}
                      <Paragraph style={{ color: '#fff' }}><MailOutlined /> {loc.email}</Paragraph>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        </div>
      );
  };

export default Info;
